<template>
    <div class="list-container">
        <h2>Manage Phase Schedules</h2>
        <button class="btn btn-sm add-btn" @click="$router.push('/dashboard/phase-schedules/add')">➕ Add Phase</button>

        <div v-if="loading" class="loading-overlay">
            <div class="spinner"></div>
        </div>

        <table class="nurse-table" v-else>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Min Days</th>
                    <th>Max Days</th>
                    <th>Description</th>
                    <th style="width: 180px;">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="phase in phases" :key="phase.id">
                    <td>{{ phase.name }}</td>
                    <td>{{ phase.min_days }}</td>
                    <td>{{ phase.max_days }}</td>
                    <td>{{ phase.description || 'N/A' }}</td>
                    <td>
                        <button class="btn btn-sm edit-btn"
                            @click="$router.push(`/dashboard/phase-schedules/edit/${phase.id}`)">✏️ Edit</button>
                        <button class="btn btn-sm btn-danger mt-1" @click="deletePhase(phase.id)">🗑️ Delete</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            phases: [],
            loading: false,
        };
    },
    methods: {
        async fetchPhases() {
            this.loading = true;
            try {
                const res = await this.$api.get("/phase-schedules");
                this.phases = res.data;
            } catch (error) {
                console.error("Error fetching phase schedules:", error);
            } finally {
                this.loading = false;
            }
        },
        async deletePhase(id) {
            if (!confirm("Are you sure you want to delete this phase schedule?")) return;
            try {
                await this.$api.delete(`/phase-schedules/${id}`);
                this.phases = this.phases.filter(p => p.id !== id);
            } catch (error) {
                console.error("Error deleting phase schedule:", error);
            }
        },
    },
    mounted() {
        this.fetchPhases();
    },
};
</script>

<style scoped>
/* reuse same styles if available, or paste styles below */

.list-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.nurse-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

.nurse-table th,
.nurse-table td {
    padding: 10px;
    border: 1px solid #ddd;
    text-align: left;
}

.nurse-table th {
    background-color: #f4f4f4;
}

.edit-btn {
    background-color: #ffc107;
    color: black;
    border: none;
}

.btn-danger {
    background-color: #dc3545;
    color: white;
}
</style>
